// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import carpark1 from '@/assets/img/car-park-1.png';
// import babAlReeLogo from '@/assets/img/Bab-Al-Ree-logo.png';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';

// // ─── Fallback Data ────────────────────────────────────────────────────────────
// const FALLBACK_PARKING = {
//   table_key: 'bab_al_ree_offstreet_parking_profile',
//   title: 'Bab Al Ree Off Street Parking - Profile',
//   data: {
//     car_park_bays:     { label: 'Total Off-Street Parking Bays', value: '390' },
//     contract_term:     { label: 'Contract Term', value: '25 years' },
//     contract_period:   { start_date: '29/03/2017', end_date: '29/06/2041' },
//     operational_hours: { label: 'Operational Hours', value: '24 Hours' },
//     vat_note:          { label: 'Rate per Hour', value: 'SAR 06.00 including 15% VAT' },
//   },
// };

// const FALLBACK_MEMBERSHIP = {
//   table_key: 'bab_al_ree_membership_tariff',
//   title: 'Membership Tariff',
//   data: {
//     columns: ['MEMBERSHIP TARIFF', 'Price'],
//     rows: [
//       ['Causal Members',       'SAR 350 + VAT'],
//       ['Shop Owners/Tenants',  'SAR 175 + VAT'],
//     ],
//   },
// };

// const FALLBACK_ASSETS = {
//   table_key: 'bab_al_ree_assets_deployed',
//   title: 'Bab Al Ree Off-Street',
//   data: {
//     groups: [
//       { group_name: 'Ticket Dispenser',    group_total_qty: '1',  items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '1' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//       { group_name: 'Ticket Verifier',     group_total_qty: '-',  items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//       { group_name: "APM's",              group_total_qty: '1',  items: [{ item_name: 'APM ETS-70', qty: '1' }, { item_name: 'APM ETS-100', qty: '-' }] },
//       { group_name: 'PIN Pad',             group_total_qty: '1',  items: [{ item_name: 'IUP250', qty: '1' }] },
//       { group_name: 'Card Reader',         group_total_qty: '1',  items: [{ item_name: 'IUR250', qty: '1' }] },
//       { group_name: 'B-Contactless',       group_total_qty: '1',  items: [{ item_name: 'IUC150', qty: '1' }] },
//       { group_name: 'RFID Reader',         group_total_qty: '2',  items: [] },
//       { group_name: 'IP Barrier',          group_total_qty: '2',  items: [] },
//       { group_name: 'ANPR Camera',         group_total_qty: '2',  items: [{ item_name: 'ARH', qty: '2' }, { item_name: 'Lumenera', qty: '-' }] },
//       { group_name: 'Sliding Gate',        group_total_qty: '-',  items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//       { group_name: "PND's",              group_total_qty: '-',  items: [{ item_name: 'TPAL BNA-Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//       { group_name: 'Pound Cashier Device',group_total_qty: '-',  items: [{ item_name: 'CN-50', qty: '-' }] },
//       { group_name: 'Driver Device',       group_total_qty: '2',  items: [{ item_name: 'CN-51', qty: '2' }] },
//       { group_name: 'Enf Device',          group_total_qty: '-',  items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//       { group_name: 'Validation',          group_total_qty: '-',  items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//       { group_name: 'Printer',             group_total_qty: '-',  items: [{ item_name: 'PR-3', qty: '2' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
//       { group_name: 'Tow Truck',           group_total_qty: '-',  items: [] },
//       { group_name: 'Clamp Vehicle',       group_total_qty: '-',  items: [] },
//       { group_name: 'Support Vehicle',     group_total_qty: '-',  items: [] },
//     ],
//   },
// };

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ─────────────────────────────────────────────────────────────────────────────
// const BabAlRee_11 = ({ year = '', monthNumber = '', contract = '' }) => {
//   const saveTimeoutRef = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);

//   const [parkingTable,    setParkingTable]    = useState(FALLBACK_PARKING);
//   const [membershipTable, setMembershipTable] = useState(FALLBACK_MEMBERSHIP);
//   const [assetsTable,     setAssetsTable]     = useState(FALLBACK_ASSETS);
// const { enqueue } = useApiQueue();

//   // ── Refs for latest state (Stale State Fix) ─────────────────────────────
//   const parkingRef    = useRef(null);
//   const membershipRef = useRef(null);
//   const assetsRef     = useRef(null);

//   // Sync refs with latest state
//   useEffect(() => {
//     parkingRef.current = parkingTable;
//   }, [parkingTable]);

//   useEffect(() => {
//     membershipRef.current = membershipTable;
//   }, [membershipTable]);

//   useEffect(() => {
//     assetsRef.current = assetsTable;
//   }, [assetsTable]);

//   // ── Fetch ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await enqueue(() =>
//  apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//         if (!response?.success) return;
//         const data = response?.data || [];
//         const find = (key, fb) => data.find(t => t.table_key === key) || fb;
//         setParkingTable(find('bab_al_ree_offstreet_parking_profile', FALLBACK_PARKING));
//         setMembershipTable(find('bab_al_ree_membership_tariff',      FALLBACK_MEMBERSHIP));
//         setAssetsTable(find('bab_al_ree_assets_deployed',            FALLBACK_ASSETS));
//       } catch (err) {
//         console.error('Fetch error:', err);
//       }
//     };
//     fetchData();
//   }, [year, monthNumber, contract]);

//   // ── Auto-save ─────────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
//     saveTimeoutRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//     // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);

//       const tables = [
//         { 
//           table_key: parkingRef.current?.table_key, 
//           title: parkingRef.current?.title, 
//           data: parkingRef.current?.data 
//         },
//         { 
//           table_key: membershipRef.current?.table_key, 
//           title: membershipRef.current?.title, 
//           data: membershipRef.current?.data 
//         },
//         { 
//           table_key: assetsRef.current?.table_key, 
//           title: assetsRef.current?.title, 
//           data: assetsRef.current?.data 
//         },
//       ];

//       const response = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, 
//         year, 
//         month: monthNumber, 
//         created_by: 1,
//         tables,
//       });

//       if (!response?.success) throw new Error(response?.message || 'Save failed');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ── Handlers ──────────────────────────────────────────────────────────────
//   const patchParking = (field, subField, value) => {
//     setParkingTable(prev => ({
//       ...prev,
//       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//     }));
//     autoSave();
//   };

//   const handleMembershipRow = (rowIdx, colIdx, value) => {
//     setMembershipTable(prev => ({
//       ...prev,
//       data: {
//         ...prev.data,
//         rows: prev.data.rows.map((row, i) =>
//           i === rowIdx ? row.map((cell, j) => j === colIdx ? value : cell) : row
//         ),
//       },
//     }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   // ── Accessors ─────────────────────────────────────────────────────────────
//   const pkd        = parkingTable.data;
//   const md         = membershipTable.data;
//   const memColumns = md.columns || [];
//   const memRows    = md.rows    || [];
//   const flatAssets = groupsToFlat(assetsTable.data.groups);

//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">

//       {/* Header — logo left, title center */}
//       <div className="flex justify-between items-center mb-2">
//         <div className="ml-2">
//           <img src={babAlReeLogo} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />
//         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{parkingTable.title}</h1>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//         {/* ── Left ── */}
//         <div className="flex-1  !border-black pr-4">
//           <div className="text-[16px] font-semibold mb-4">Activities:</div>

//           {/* Car Park image box */}
//           {/* <div className="!border !border-gray-300 rounded p-3 mb-4 w-[130px] flex flex-col items-center ml-4">
//             <span className="text-[10px] text-gray-500 mb-1">Car Park</span>
//             <img src={carpark1} alt="Car Park" className="w-16 h-16 object-contain" />
//           </div> */}
//            <div className=" rounded mb-4 w-[140px] flex flex-col items-center">
//                               {/* <span className="text-[10px] text-gray-500 mb-1">Car Park</span> */}
//                               <img src={carpark1} alt="Car Park" className="w-48 h-48 object-contain" />
//                             </div>

//           {/* Total Bays */}
//           <div className="flex items-center gap-2 mb-1 ml-4">
//             <div className="w-4 h-4 !border-2 !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               {pkd.car_park_bays?.label}{' '}
//               <strong>
//                 <input type="text" value={pkd.car_park_bays?.value || ''}
//                   onChange={e => patchParking('car_park_bays', 'value', e.target.value)}
//                   className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" />
//               </strong>
//             </span>
//           </div>

//           {/* Contract Term */}
//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]   flex-wrap gap-1">
//               Contract term{' '}
//               <strong><input type="text" value={pkd.contract_term?.value || ''}
//                 onChange={e => patchParking('contract_term', 'value', e.target.value)}
//                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12.5" /></strong>
//               ; start date{' '}
//               <strong><input type="text" value={pkd.contract_period?.start_date || ''}
//                 onChange={e => patchParking('contract_period', 'start_date', e.target.value)}
//                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-14" /></strong>
//               {' to '}
//               <strong><input type="text" value={pkd.contract_period?.end_date || ''}
//                 onChange={e => patchParking('contract_period', 'end_date', e.target.value)}
//                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
//             </span>
//           </div>

//           {/* Operational Hours */}
//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               Operational Hours –{' '}
//               <strong>
//                 <input type="text" value={pkd.operational_hours?.value || ''}
//                   onChange={e => patchParking('operational_hours', 'value', e.target.value)}
//                   className="font-bold outline-none bg-transparent !border-0 text-[12px]" />
//               </strong>
//             </span>
//           </div>

//           {/* Rate per Hour */}
//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               Rate per Hour{' '}
//               <strong>
//                 <input type="text" value={pkd.vat_note?.value || ''}
//                   onChange={e => patchParking('vat_note', 'value', e.target.value)}
//                   className="font-bold outline-none bg-transparent !border-0 text-[12px]" />
//               </strong>
//             </span>
//           </div>

//           {/* Assets Deployed */}
//           <div className="flex items-center gap-2 ml-4 mb-6">
//             <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//             <span className="text-[12px]">Assets Deployed</span>
//           </div>

//           {/* Membership Tariff Table */}
//           <div className="ml-4">
//             <table className="!border-collapse text-[11px]">
//               <thead>
//                 <tr>
//                   {/* {memColumns.map((col, i) => (
//                     <th key={i} className="!border !border-black px-3 py-1.5 font-bold text-center bg-gray-100"
//                       style={{ minWidth: i === 0 ? '160px' : '110px' }}>
//                       {col}
//                     </th>
//                   ))} */}
//                   <th colSpan={2} className="!border !border-black px-3 py-1.5 font-bold text-center">MEMBERSHIP TARIFF</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {memRows.map((row, rIdx) => (
//                   <tr key={rIdx}>
//                     {row.map((cell, cIdx) => (
//                       <td key={cIdx} className="!border !border-black px-3 py-1.5">
//                         <input type="text" value={cell}
//                           onChange={e => handleMembershipRow(rIdx, cIdx, e.target.value)}
//                           className="outline-none bg-transparent !border-0 w-full text-[11px]" />
//                       </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* ── Right — Assets ── */}
//         <AssetsPanel
//           assetsTable={assetsTable}
//           flatAssets={flatAssets}
//           onSubCount={handleAssetSubCount}
//           onTotalCount={handleAssetTotalCount}
//         />

//       </div>

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">Saving...</div>
//       )} */}
//     </div>
//   );
// };

// export default BabAlRee_11;





import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import carpark1 from '@/assets/img/car-park-1.png';
import babAlReeLogo from '@/assets/img/Bab-Al-Ree-logo.png';
import { useApiQueue } from '@/hooks/useApiQueue';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ─── Fallback Data ────────────────────────────────────────────────────────────
const FALLBACK_PARKING = {
  table_key: 'bab_al_ree_offstreet_parking_profile',
  title: 'Bab Al Ree Off Street Parking - Profile',
  data: {
    car_park_bays:     { label: 'Total Off-Street Parking Bays', value: '390' },
    contract_term:     { label: 'Contract Term', value: '25 years' },
    contract_period:   { start_date: '29/03/2017', end_date: '29/06/2041' },
    operational_hours: { label: 'Operational Hours', value: '24 Hours' },
    vat_note:          { label: 'Rate per Hour', value: 'SAR 06.00 including 15% VAT' },
  },
};

const FALLBACK_MEMBERSHIP = {
  table_key: 'bab_al_ree_membership_tariff',
  title: 'Membership Tariff',
  data: {
    columns: ['MEMBERSHIP TARIFF', 'Price'],
    rows: [
      ['Causal Members',       'SAR 350 + VAT'],
      ['Shop Owners/Tenants',  'SAR 175 + VAT'],
    ],
  },
};

const FALLBACK_ASSETS = {
  table_key: 'bab_al_ree_assets_deployed',
  title: 'Bab Al Ree Off-Street',
  data: {
    groups: [
      { group_name: 'Ticket Dispenser',    group_total_qty: '1',  items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '1' }, { item_name: 'G100 32 Bit', qty: '-' }] },
      { group_name: 'Ticket Verifier',     group_total_qty: '-',  items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
      { group_name: "APM's",              group_total_qty: '1',  items: [{ item_name: 'APM ETS-70', qty: '1' }, { item_name: 'APM ETS-100', qty: '-' }] },
      { group_name: 'PIN Pad',             group_total_qty: '1',  items: [{ item_name: 'IUP250', qty: '1' }] },
      { group_name: 'Card Reader',         group_total_qty: '1',  items: [{ item_name: 'IUR250', qty: '1' }] },
      { group_name: 'B-Contactless',       group_total_qty: '1',  items: [{ item_name: 'IUC150', qty: '1' }] },
      { group_name: 'RFID Reader',         group_total_qty: '2',  items: [] },
      { group_name: 'IP Barrier',          group_total_qty: '2',  items: [] },
      { group_name: 'ANPR Camera',         group_total_qty: '2',  items: [{ item_name: 'ARH', qty: '2' }, { item_name: 'Lumenera', qty: '-' }] },
      { group_name: 'Sliding Gate',        group_total_qty: '-',  items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
      { group_name: "PND's",              group_total_qty: '-',  items: [{ item_name: 'TPAL BNA-Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
      { group_name: 'Pound Cashier Device',group_total_qty: '-',  items: [{ item_name: 'CN-50', qty: '-' }] },
      { group_name: 'Driver Device',       group_total_qty: '2',  items: [{ item_name: 'CN-51', qty: '2' }] },
      { group_name: 'Enf Device',          group_total_qty: '-',  items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
      { group_name: 'Validation',          group_total_qty: '-',  items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
      { group_name: 'Printer',             group_total_qty: '-',  items: [{ item_name: 'PR-3', qty: '2' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
      { group_name: 'Tow Truck',           group_total_qty: '-',  items: [] },
      { group_name: 'Clamp Vehicle',       group_total_qty: '-',  items: [] },
      { group_name: 'Support Vehicle',     group_total_qty: '-',  items: [] },
    ],
  },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ─────────────────────────────────────────────────────────────────────────────
const BabAlRee_11 = ({ year = '', month = '', monthNumber = '', contract = '' }) => {
  const saveTimeoutRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  const hasFetchedRef = useRef(false);

  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);

  const [parkingTable,    setParkingTable]    = useState(FALLBACK_PARKING);
  const [membershipTable, setMembershipTable] = useState(FALLBACK_MEMBERSHIP);
  const [assetsTable,     setAssetsTable]     = useState(FALLBACK_ASSETS);
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? parkingTable.data.car_park_bays?.value ?? '390';

  // ── Refs for latest state (Stale State Fix) ─────────────────────────────
  const parkingRef    = useRef(null);
  const membershipRef = useRef(null);
  const assetsRef     = useRef(null);

  // Sync refs with latest state
  useEffect(() => {
    parkingRef.current = parkingTable;
  }, [parkingTable]);

  useEffect(() => {
    membershipRef.current = membershipTable;
  }, [membershipTable]);

  useEffect(() => {
    assetsRef.current = assetsTable;
  }, [assetsTable]);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params - 'type' not 'value'
      const secondApiParams = {
        contract: "0020010",
        year: year,
        month: month,     // using 'month' (string like "Oct")
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;
        setParkingTable(find('bab_al_ree_offstreet_parking_profile', FALLBACK_PARKING));
        setMembershipTable(find('bab_al_ree_membership_tariff',      FALLBACK_MEMBERSHIP));
        setAssetsTable(find('bab_al_ree_assets_deployed',            FALLBACK_ASSETS));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      const tables = [
        { 
          table_key: parkingRef.current?.table_key, 
          title: parkingRef.current?.title, 
          data: parkingRef.current?.data 
        },
        { 
          table_key: membershipRef.current?.table_key, 
          title: membershipRef.current?.title, 
          data: membershipRef.current?.data 
        },
        { 
          table_key: assetsRef.current?.table_key, 
          title: assetsRef.current?.title, 
          data: assetsRef.current?.data 
        },
      ];

      const response = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, 
        year, 
        month: monthNumber, 
        created_by: 1,
        tables,
      });

      if (!response?.success) throw new Error(response?.message || 'Save failed');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Handlers ──────────────────────────────────────────────────────────────
  const patchParking = (field, subField, value) => {
    setParkingTable(prev => ({
      ...prev,
      data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
    }));
    autoSave();
  };

  const handleMembershipRow = (rowIdx, colIdx, value) => {
    setMembershipTable(prev => ({
      ...prev,
      data: {
        ...prev.data,
        rows: prev.data.rows.map((row, i) =>
          i === rowIdx ? row.map((cell, j) => j === colIdx ? value : cell) : row
        ),
      },
    }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  // ── Accessors ─────────────────────────────────────────────────────────────
  const pkd        = parkingTable.data;
  const md         = membershipTable.data;
  const memColumns = md.columns || [];
  const memRows    = md.rows    || [];
  const flatAssets = groupsToFlat(assetsTable.data.groups);

  return (
    <div className="min-h-screen p-8 bg-white">

      {/* Header — logo left, title center */}
      <div className="flex justify-between items-center mb-2">
        <div className="ml-2">
          <img src={babAlReeLogo} alt="Bab Al Ree Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{parkingTable.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-3">

        {/* ── Left ── */}
        <div className="flex-1  !border-black pr-4">
          <div className="text-[16px] font-semibold mb-4">Activities:</div>

          {/* Car Park image box */}
          <div className="rounded mb-4 w-[140px] flex flex-col items-center">
            <img src={carpark1} alt="Car Park" className="w-48 h-48 object-contain" />
          </div>

          {/* 🔥 READ-ONLY Total Bays - Second API se aayega */}
          <div className="flex items-center gap-2 mb-1 ml-4">
            <div className="w-4 h-4 !border-2 !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              {pkd.car_park_bays?.label}{' '}
              <strong>
                <input 
                  type="text" 
                  value={effectiveTotalBays} 
                  readOnly 
                  disabled
                  className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default"
                />
              </strong>
            </span>
          </div>

          {/* Contract Term - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px] flex-wrap gap-1">
              Contract term{' '}
              <strong><input type="text" value={pkd.contract_term?.value || ''}
                onChange={e => patchParking('contract_term', 'value', e.target.value)}
                className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12.5" /></strong>
              ; start date{' '}
              <strong><input type="text" value={pkd.contract_period?.start_date || ''}
                onChange={e => patchParking('contract_period', 'start_date', e.target.value)}
                className="font-bold outline-none bg-transparent !border-0 text-[12px] w-14" /></strong>
              {' to '}
              <strong><input type="text" value={pkd.contract_period?.end_date || ''}
                onChange={e => patchParking('contract_period', 'end_date', e.target.value)}
                className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
            </span>
          </div>

          {/* Operational Hours - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              Operational Hours –{' '}
              <strong>
                <input type="text" value={pkd.operational_hours?.value || ''}
                  onChange={e => patchParking('operational_hours', 'value', e.target.value)}
                  className="font-bold outline-none bg-transparent !border-0 text-[12px]" />
              </strong>
            </span>
          </div>

          {/* Rate per Hour - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              Rate per Hour{' '}
              <strong>
                <input type="text" value={pkd.vat_note?.value || ''}
                  onChange={e => patchParking('vat_note', 'value', e.target.value)}
                  className="font-bold outline-none bg-transparent !border-0 text-[12px]" />
              </strong>
            </span>
          </div>

          {/* Assets Deployed */}
          <div className="flex items-center gap-2 ml-4 mb-6">
            <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
            <span className="text-[12px]">Assets Deployed</span>
          </div>

          {/* Membership Tariff Table - Editable */}
          <div className="ml-4">
            <table className="!border-collapse text-[11px]">
              <thead>
                <tr>
                  <th colSpan={2} className="!border !border-black px-3 py-1.5 font-bold text-center">MEMBERSHIP TARIFF</th>
                </tr>
              </thead>
              <tbody>
                {memRows.map((row, rIdx) => (
                  <tr key={rIdx}>
                    {row.map((cell, cIdx) => (
                      <td key={cIdx} className="!border !border-black px-3 py-1.5">
                        <input type="text" value={cell}
                          onChange={e => handleMembershipRow(rIdx, cIdx, e.target.value)}
                          className="outline-none bg-transparent !border-0 w-full text-[11px]" />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Right — Assets ── */}
        <AssetsPanel
          assetsTable={assetsTable}
          flatAssets={flatAssets}
          onSubCount={handleAssetSubCount}
          onTotalCount={handleAssetTotalCount}
        />

      </div>
    </div>
  );
};

export default BabAlRee_11;